/* MWAMI storefront helpers: hero parallax, glass header on scroll,
   and engagement weighted ordering of product grids. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function heroEls() {
    return document.querySelectorAll('.carousel-slide-image, .feature-video-container-inner video');
  }

  /* ---------- Hero parallax + scrolled state ---------- */
  function initScroll() {
    var hero = document.querySelector('.carousel-container, .feature-video-container');
    var layers = heroEls();
    var ticking = false;

    function update() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var h = hero ? hero.offsetHeight : 400;
      if (!reduceMotion && hero && y < h + 50) {
        var shift = Math.round(y * 0.35);
        for (var i = 0; i < layers.length; i++) {
          layers[i].style.transform = 'translate3d(0,' + shift + 'px,0)';
        }
      }
      document.body.classList.toggle('mw-scrolled', y > Math.max(60, h - 90));
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* Placeholder "." headings were used to hide hero text; drop them */
  function cleanHeroText() {
    var heads = document.querySelectorAll('.carousel-slide-text h1, .carousel-slide-text p, .feature-video-slide-text h1, .feature-video-slide-text p');
    for (var i = 0; i < heads.length; i++) {
      if (heads[i].textContent.trim() === '.' || heads[i].textContent.trim() === '') heads[i].style.display = 'none';
    }
  }

  /* ---------- Engagement weighted shuffle ----------
     Each grid item carries data-mw-score (from the product metafield
     mwami.engagement_score). Weighted random sampling without replacement
     (Efraimidis Spirakis): key = rand^(1/weight). Higher scores surface
     first more often, but every visit gets a fresh mix. */
  function weightedShuffle(grid) {
    var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > .grid__item[data-mw-score]'));
    if (items.length < 2) return;
    var spacers = Array.prototype.slice.call(grid.children).filter(function (c) { return items.indexOf(c) === -1; });
    items.forEach(function (el) {
      var w = parseFloat(el.getAttribute('data-mw-score')) || 1;
      if (el.getAttribute('data-mw-available') === 'false') w = w * 0.35;
      el._mwKey = Math.pow(Math.random(), 1 / Math.max(w, 0.05));
    });
    items.sort(function (a, b) { return b._mwKey - a._mwKey; });
    items.forEach(function (el) { grid.appendChild(el); });
    spacers.forEach(function (el) { grid.appendChild(el); });
  }

  function initShuffle() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('sort_by')) return; // visitor chose an explicit sort
    var grids = document.querySelectorAll('.grid--products[data-mw-shuffle="true"]');
    for (var i = 0; i < grids.length; i++) weightedShuffle(grids[i]);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initShuffle();
    cleanHeroText();
    initScroll();
  });
})();
